import {graphqlClient} from '@/services/graphqlClient';
import {
  useGetMyWorkTimeStatusQuery,
  WorkTimeSessionState,
} from '@/services/graphqlHooks';

import {useCanTrackWorkTime} from './useCanTrackWorkTime';

export const useMyWorkTimeStatus = () => {
  const canTrackWorkTime = useCanTrackWorkTime();
  const workTimeStatus = useGetMyWorkTimeStatusQuery(graphqlClient, undefined, {
    enabled: canTrackWorkTime,
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
  const status = workTimeStatus.data?.getMyWorkTimeStatus;

  return {
    isWorking: status?.state === WorkTimeSessionState.Working,
    activeSession: status?.activeSession ?? undefined,
    isFetching: workTimeStatus.isFetching,
  };
};
